var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.displayTitle))]), _c('div', {
    staticClass: "game-container"
  }, [_c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.statusText))]), _c('canvas', {
    ref: "gameCanvas"
  }), _vm.gameWon ? _c('div', {
    staticClass: "win-message"
  }, [_vm._v(" 🎉 恭喜！您完成了迷宮！"), _c('br'), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.resetGame
    }
  }, [_vm._v(" 再玩一次 ")])], 1) : _vm._e(), _vm._m(0)]), _c('div', {
    staticClass: "controls"
  }, [_c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "disabled": _vm.gameRunning
    },
    on: {
      "click": _vm.startGame
    }
  }, [_vm._v(" " + _vm._s(_vm.startButtonText) + " ")]), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-secondary s-btn-xs",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.testMovement
    }
  }, [_vm._v(" 測試移動 ")]), _c('div', {
    staticClass: "info"
  }, [_vm._v("請允許陀螺儀權限以開始遊戲，或使用鍵盤方向鍵")])], 1)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "instructions"
  }, [_vm._v(" 傾斜設備來控制彈珠移動"), _c('br'), _vm._v(" 避開紅色障礙物"), _c('br'), _vm._v(" 到達綠色終點 ")]);
}]

export { render, staticRenderFns }